import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import './index.css';function SystemIcon({
  "aria-label": ariaLabel,
  children,
  className,
  name,
  isPhosphor = false,
  size,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "i",
    {
      ...props,
      className: `systemIconBase${className ? ` ${className}` : ""}`,
      "data-stb-system-icon": "true",
      "data-component-info": `pretzel-system-icon,${isPhosphor ? "phosphor" : "storebrand"},${name}`,
      "data-phosphor-icons": isPhosphor,
      style: size ? {
        height: `${size / 16}rem`,
        width: `${size / 16}rem`,
        fontSize: `${size / 16}rem`,
        lineHeight: `${size / 16}rem`
      } : {},
      role: ariaLabel ? "img" : void 0,
      "aria-hidden": ariaLabel ? void 0 : "true",
      title: ariaLabel,
      translate: "no",
      children: name || children
    }
  );
}
const typeToIcon = {
  info: "information-filled",
  "info-subtle": "information-filled",
  success: "check-circle-filled",
  warning: "warning-filled",
  error: "error-filled"
};
function AlertInline({
  title,
  variant = "info-subtle",
  className,
  role,
  ...props
}) {
  const icon = useMemo(() => typeToIcon == null ? void 0 : typeToIcon[variant], [variant]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...props,
      className: `alertInlineBase${className ? ` ${className}` : ""}`,
      "data-variant": variant,
      "data-stb-alert-inline": "true",
      "data-component-info": "pretzel-alert-inline",
      children: [
        /* @__PURE__ */ jsx(SystemIcon, { className: "alertIcon font-small-demibold", name: icon }),
        /* @__PURE__ */ jsx("div", { role, className: "alertTitle font-small-demibold", children: title })
      ]
    }
  );
}
export {
  AlertInline,
  AlertInline as default
};
